import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20warm%20peach%20and%20soft%20coral%20gradient%20flowing%20silk%20waves%20with%20golden%20light%20particles%2C%20dreamy%20ethereal%20atmosphere%2C%20elegant%20smooth%20curves%2C%20luxurious%20and%20inviting%20feeling%2C%20high%20quality%20abstract%20art%20with%20soft%20focus%20background&width=1920&height=1080&seq=hero-bg-main&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <i className="ri-sparkling-2-fill text-accent-400 text-sm"></i>
            <span className="text-sm text-background-50/90 font-medium">全新版本 · 极速体验</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
            蜜桃在线
            <span className="block text-lg md:text-2xl lg:text-3xl font-body font-light mt-3 text-background-50/80">
              官方入口 · 极速体验
            </span>
          </h1>

          <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto mb-8 leading-relaxed">
            蜜桃在线是您首选的在线娱乐平台，提供极速稳定的访问体验、丰富多样的内容资源与贴心的用户服务。随时随地，轻松畅享全新在线体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              立即体验
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-background-50">500万+</div>
              <div className="text-xs text-background-50/60 mt-1">活跃用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-background-50">200+</div>
              <div className="text-xs text-background-50/60 mt-1">加速节点</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-background-50">99.9%</div>
              <div className="text-xs text-background-50/60 mt-1">服务可用率</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/50"></i>
      </div>
    </section>
  );
}